export default {
  parts: 'Parts',

  'parts.entity.name': 'Name',
  'parts.entity.description': 'Description',
  'parts.entity.partApplicationDescription': 'Application Description',
  'parts.entity.barCode': 'Barcode',
  'parts.entity.manufacturer': 'Manufacturer',
  'parts.entity.sku': 'Internal Code',
  'parts.entity.companyCode': 'Company Code',
  'parts.entity.manufacturerCode': 'Manufacturer Code',
  'parts.entity.manufacturingCode': 'Manufacturer Code',
  'parts.entity.originalCode': 'Manufacturer Code',
  'parts.entity.includeInDiagnosis': 'Include in Diagnosis',
  'parts.entity.lifeSpan': 'Life Span (days)',
  'parts.entity.cfop': 'CFOP',
  'parts.entity.ncm': 'NCM',
  'parts.entity.unit': 'Unit',
  'parts.entity.subGroup': 'Group',
  'parts.entity.kmToMaintenance': 'Maintenance Km',
  'parts.entity.comment': 'Comment',
  'parts.entity.addPartImage': 'Add Part Image',
  'parts.entity.location': 'Location',

  'parts.create': 'Create New Part',
  'parts.create.notifications.success.title': 'Success',
  'parts.create.notifications.success.description': 'Part created.',

  'parts.details': 'Part Details',

  'parts.update.notifications.success.title': 'Success',
  'parts.update.notifications.success.description': 'Part updated.',

  'parts.remove.confirm.title': 'Remove part',
  'parts.remove.confirm.content':
    'Do you really want to delete the selected part?',
  'parts.remove.success.message': 'Success',
  'parts.remove.success.description': 'Part removed.',

  'parts.changePrices': 'Change Prices',

  'parts.stock': 'Stock',
  'parts.stock.domain.company': 'Company',
  'parts.stock.domain.stock': 'Stock',
  'parts.stock.domain.availableStock': 'Available Stock',
  'parts.stock.domain.sellPrice': '(US$) Sell Price',
  'parts.stock.domain.commissionPercentage': '(%) Commission',
  'parts.stock.domain.minStock': 'Min Stock',
  'parts.stock.domain.maxStock': 'Max Stock',
  'parts.stock.domain.buyPrice': '(US$) Buy Price',
  'parts.stock.domain.ipi': '(%) IPI',
  'parts.stock.domain.taxReplacement': '(US$) Tax Replacement',
  'parts.stock.domain.fixedCost': '(%) Fixed Cost',
  'parts.stock.domain.icmsExemption': '(US$) ICMS Exemption',
  'parts.stock.domain.freightCost': '(US$) Freight COst',
  'parts.stock.domain.otherExpenses': '(US$) Other Expenses',
  'parts.stock.domain.realCost': '(US$) Real Cost',
  'parts.stock.domain.maxDiscount': '(%) Max Discount',
  'parts.stock.domain.location': 'Location',
  'parts.stock.domain.profitMargin': 'Profit Margin',

  'parts.lastPurchases.domain.code': 'Purchase Number',
  'parts.lastPurchases.domain.supplier': 'Supplier',
  'parts.lastPurchases.domain.releaseDate': 'Release Date',
  'parts.lastPurchases.domain.quantity': 'Quantity',
  'parts.lastPurchases.domain.unitaryValue': 'Unitary Value',
  'parts.lastPurchases.domain.totalAmountItem': 'Amount',
  'parts.lastPurchases.domain.averageCostLastPurchases':
    'Average cost of the part in the last purchases: ',

  'parts.stock.enabledCostFields':
    'For the selected company: {company}, the following fields are being used for the "Real Cost"',

  'parts.stock.update.notifications.success.title': 'Success',
  'parts.stock.update.notifications.success.description':
    'Company stock updated.',

  'parts.application.modal.form.brand': 'Brand',
  'parts.application.modal.form.model': 'Model',
  'parts.application.modal.form.fromYear': 'From Year',
  'parts.application.modal.form.toYear': 'To Year',

  'parts.application.modal.create.success.title': 'Success!',
  'parts.application.modal.create.success.description':
    'Application of the created part!',
  'parts.application.modal.remove.title': 'Remove Application',
  'parts.application.modal.remove.content':
    'If you really want to remove this application, when you confirm it will be deleted from the database. Still want to continue?',
  'parts.application.modal.remove.success.description':
    'Application removed successfully!',

  'parts.generateReport': 'Generate Report',
  'parts.modal.report.title': 'Generate Report',
  'parts.modal.report.buttons.viewReport': 'View Report',
  'parts.modal.report.buttons.pdf': 'Generate PDF',
  'parts.modal.report.buttons.rtf': 'Generate RTF',
  'parts.modal.report.buttons.csv': 'Generate CSV',
  'parts.modal.report.form.description': 'Description',
  'parts.modal.report.form.group': 'Group',
  'parts.modal.report.form.manufacturers': 'Manufacturers',
  'parts.modal.report.form.companies': 'Companies',
  'parts.modal.report.form.localization': 'Localization, From',
  'parts.modal.report.form.localizationUpUntil': 'Até',
  'parts.modal.report.form.detailTheProducts': 'Detail the Products',
  'parts.modal.report.form.viewPartApplication': 'View part application',
  'parts.modal.report.form.viewActualCostPart': 'View actual part cost',
  'parts.modal.report.form.showPartCodesOnCSV': 'Show part codes on CSV',
  'parts.modal.report.form.showPartCfop': 'View CFOP of the part',
  'parts.modal.report.form.inhibitPartsStockWithZero':
    'Inhibit parts with zero stock?',
  'parts.modal.report.form.yes': 'Yes',
  'parts.modal.report.form.no': 'No',
  'parts.modal.report.form.order': 'Order',
  'parts.modal.report.form.descriptionOrder': 'Description',
  'parts.modal.report.form.localization': 'Localization',
  'parts.modal.report.form.internalCode': 'Internal Code',

  'parts.partsReplacement.part': 'Part',
  'parts.partsReplacement.modal.title': 'Select Part',
  'parts.partsReplacement.modal.description': 'Description',
  'parts.partsReplacement.modal.manufacturingCode': 'Manufacturing Code',
  'parts.partsReplacement.modal.barCode': 'Bar Code',
  'parts.partsReplacement.modal.internalCode': 'Internal Code',
  'parts.partsReplacement.modal.companyCode': 'Company Code',

  'parts.partsReplacement.filters.manufacturingCode': 'Manufacturing Code',
  'parts.partsReplacement.filters.barCode': 'Bar Code',
  'parts.partsReplacement.filters.internalCode': 'Internal Code',
  'parts.partsReplacement.filters.companyCode': 'company Code',

  'parts.partsReplacement.btn.addReplacementPart': 'Add Replacement Part',
  'parts.partsReplacement.btn.addReplacementPartLink':
    'Add Replacement Part and link the other related parts',

  'parts.partsReplacement.create.notification.success': 'Success',
  'parts.partsReplacement.create.notification.successDescription':
    'Replacement part created.',

  'parts.partsReplacement.create.notification.removeDescription':
    'Replacement part removed.',

  'parts.status.message.success': 'Part status changed successfully!',

  'parts.error.internalCode.alreadyExists':
    'There is already a part registered with this internal code',
  'parts.error.barCode.alreadyExists':
    'There is already a part registered with this barcode',
  'parts.error.remove.bonds':
    'The action could not be completed due to a violation of the links for this record!',
};
